import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SiteNav from "@/components/SiteNav";
import SiteFooter from "@/components/SiteFooter";
import GlobalTextures from "@/components/GlobalTextures";

import HomePage from "@/pages/Home";
import ReleasesPage from "@/pages/Releases";
import ReleaseDetail from "@/pages/ReleaseDetail";
import PortalsPage from "@/pages/Portals";
import AffiliatesPage from "@/pages/Affiliates";
import SubmitPage from "@/pages/Submit";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

import { AuthProvider } from "@/lib/auth";

function PublicLayout({ children }) {
  return (
    <>
      <SiteNav />
      <main>{children}</main>
      <SiteFooter />
    </>
  );
}

function App() {
  return (
    <div className="App relative">
      <GlobalTextures />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <PublicLayout>
                  <HomePage />
                </PublicLayout>
              }
            />
            <Route
              path="/releases"
              element={
                <PublicLayout>
                  <ReleasesPage />
                </PublicLayout>
              }
            />
            <Route
              path="/releases/:catalogue"
              element={
                <PublicLayout>
                  <ReleaseDetail />
                </PublicLayout>
              }
            />
            <Route
              path="/portals"
              element={
                <PublicLayout>
                  <PortalsPage />
                </PublicLayout>
              }
            />
            <Route
              path="/affiliates"
              element={
                <PublicLayout>
                  <AffiliatesPage />
                </PublicLayout>
              }
            />
            <Route
              path="/submit"
              element={
                <PublicLayout>
                  <SubmitPage />
                </PublicLayout>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ead7af",
            border: "1px solid #a87a3f",
            color: "#3d2614",
            borderRadius: 0,
            fontFamily: "IBM Plex Mono, monospace",
            boxShadow: "3px 3px 0 0 #2c1a0c",
          },
        }}
      />
    </div>
  );
}

export default App;
